import { __assign, __read, __spreadArray } from 'tslib';
import React__default from 'react';

var TextVariablesContext = React__default.createContext({});
/**
 * This function will replace keywords to values and can return string or array
 */
var flatMap = function (splitText, keywords, cbGetKeywordValue) {
    var text = [];
    for (var i = 0; i < splitText.length; i++) {
        var keyword = keywords[i] || '';
        var cleanKeyword = keyword.slice(2, -2);
        var response = cbGetKeywordValue(cleanKeyword);
        text = __spreadArray(__spreadArray([], __read(text), false), [splitText[i], response], false);
    }
    var stringText = text.some(function (currentText) { return typeof currentText === 'object'; });
    if (!stringText) {
        return text.join('');
    }
    return text;
};
var INTERPOLATION_REGEX = /\{{\w+\}}/g;
var useUpdateFields = function (_a) {
    var fields = _a.fields, _b = _a.keywordsTexts, keywordsTexts = _b === void 0 ? {} : _b;
    var defaultTextVariables = React__default.useContext(TextVariablesContext);
    var textVariables = __assign(__assign({}, defaultTextVariables), keywordsTexts);
    if (!fields)
        return { originalFields: fields, updatedFields: fields };
    var updatedFields = Object.entries(fields).reduce(function (acc, field) {
        var _a;
        var _b = __read(field, 2), key = _b[0], value = _b[1];
        if (typeof value !== 'string')
            return acc;
        var keywords = value.match(INTERPOLATION_REGEX) || [];
        var splitText = value.split(INTERPOLATION_REGEX);
        if (!keywords || !keywords.length)
            return acc;
        return __assign(__assign({}, acc), (_a = {}, _a[key] = flatMap(splitText, keywords, function (keyword) {
            if (!keyword)
                return '';
            return textVariables[keyword] || "{".concat(keyword, "}");
        }), _a));
    }, fields);
    return { originalFields: fields, updatedFields: updatedFields };
};

export { TextVariablesContext, useUpdateFields };
//# sourceMappingURL=index.esm.js.map
